import {IconButton } from "@mui/material";
import {BugReport, BugReportOutlined, List, ListAltOutlined, TrackChanges} from "@mui/icons-material";
import React, {useEffect, useState} from "react";
import { connect } from "react-redux";
import {selectModeData, selectProject, selectUserId} from "../../../redux/selectors/editor";
import {IGraphData, updateFocus} from "../../../redux/slices/editor";
import SearchTool from "./SearchTool";
import {selectNetwork, selectProjects} from "../../../redux/selectors/firebase";
import {ProjectDetails} from "../../../redux/types/firebase";
import StateLock from "../StateLock";
import {NetworkData} from "../../../fstn/network";

export interface IGraphToolsProps
{
    onFocusCurrent: () => any
    onSetShowDebug: (value: boolean) => any
    onSetShowRegisters: (value: boolean) => any
    showDebug: boolean
    showRegisters: boolean
}
interface IGraphToolsRedux
{
    graphData: IGraphData
    network: NetworkData
    project: string
    projects: {[project: string]: ProjectDetails}
    updateFocus: (focus: string) => any,
}
function GraphTools({graphData, network, project, projects, onFocusCurrent, onSetShowDebug, onSetShowRegisters,
                        showDebug, showRegisters, updateFocus}: IGraphToolsProps & IGraphToolsRedux)
{
    const [showLock, setShowLock] = useState(false);
    const [currentResult, setCurrentResult] = useState("");
    const [searchResults, setSearchResults] = useState<string[]>([]);
    const handleSearchText = (text: string) =>
    {
        if (network.states[text] !== undefined) {
            setSearchResults([text]);
            setCurrentResult(text);
            updateFocus(text);
        } else {
            const results = Object.keys(network.states)
                .filter(key => network.states[key].script.includes(text) || network.states[key].name?.includes(text));

            setSearchResults(results);
            if (results.length) {
                setCurrentResult(results[0]);
                updateFocus(results[0]);
            }
        }
    };
    const handleSearchDown = () => {
        if (searchResults.length) {
            let index = searchResults.indexOf(currentResult) + 1;

            if (index >= searchResults.length) {
                index = 0;
            }
            setCurrentResult(searchResults[index]);
            updateFocus(searchResults[index]);
        }
    }
    const handleSearchUp = () => {
        if (searchResults.length) {
            let index = searchResults.indexOf(currentResult) - 1;

            if (index === -1) {
                index = searchResults.length - 1;
            }
            setCurrentResult(searchResults[index]);
            updateFocus(searchResults[index]);
        }
    }
    const handleClickShowDebug = () =>
    {
        onSetShowDebug(!showDebug);
    }
    const handleClickShowRegisters = () =>
    {
        onSetShowRegisters(!showRegisters);
    }
    const debugTitle = `Enable debug tools: Currently ${showDebug ? "on" : "off"}`;
    const registerTitle = `Show register values: Currently ${showRegisters ? "on" : "off"}`;

    useEffect(() => {
        if (projects) {
            setShowLock(projects[project]?.cookbook);
        }
    }, [project, projects]);

    return <>
        {showLock && <StateLock project={project} size="medium" state={graphData.root}/>}
        <SearchTool
            count={searchResults.length} index={searchResults.indexOf(currentResult)}
            searchText={handleSearchText} searchUp={handleSearchUp} searchDown={handleSearchDown}/>

        <IconButton
            color="inherit"
            onClick={handleClickShowRegisters}
            title={registerTitle}
            size="large">
            {showRegisters ? <List /> : <ListAltOutlined />}
        </IconButton>
        <IconButton
            color="inherit"
            onClick={handleClickShowDebug}
            title={debugTitle}
            size="large">
            {showDebug ? <BugReport /> : <BugReportOutlined />}
        </IconButton>
        <IconButton
            color="inherit"
            onClick={onFocusCurrent}
            title="Focus on current network state"
            size="large">
            <TrackChanges />
        </IconButton>
    </>;
}
const mapStateToProps = (store: never) => ({
    graphData: selectModeData(store) as IGraphData,
    network: selectNetwork(store),
    project: selectProject(store),
    projects: selectProjects(store),
    user: selectUserId(store),
});

export default connect(mapStateToProps, {
    updateFocus,
})(GraphTools);
